import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    marginTop: 17,
    marginBottom: -20,
  },
  infoItemContainerStyle: (withBorder, theme) => ({
    marginBottom: 16.6,
    marginVertical: 0,
    paddingBottom: 15,
    borderBottomWidth: withBorder ? 1 : 0,
    borderBottomColor: theme.colors.borderColorThree,
  }),
  infoItemTopStyle: theme => ({
    marginTop: -15,
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: theme.colors.borderColorThree,
  }),
});
